/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getLatestQuotation } from "api";
import { latestQuotationQueryKeys } from "./latestQuotationQueryKeys";

interface IFilterParmas {
  freight_mode: string;
  results: number;
}

export function useGetLatestQuotation(filters: IFilterParmas, options: UseQueryOptions) {
  return useQuery({
    queryKey: latestQuotationQueryKeys.quotations(filters),
    queryFn: () => getLatestQuotation({ params: filters }).then((res) => res.data),
    ...options,
  });
}
